import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import UploadInvoicesIcon from '@fingo/lib/assets/icons/itau/UploadInvoicesIcon';
import UploadInvoicesButton from '../buttons/UploadInvoicesButton';

const AvailableFactoringOverlay = () => (
  <Stack
    alignItems="center"
    justifyContent="center"
    spacing={2}
    sx={{
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      zIndex: 5,
    }}
  >
    <Box sx={{
      position: 'absolute',
      width: 1170,
      height: 1016,
      right: -125,
      bottom: -690,
      borderRadius: '50%',
      background: 'linear-gradient(221.74deg, #EAEFFF 22.49%, #F4F8FF 78.14%)',
      zIndex: -2,
    }}
    />
    <Box sx={{
      position: 'absolute',
      width: 1170,
      height: 1016,
      right: -125,
      bottom: -690,
      borderRadius: '50%',
      background: 'linear-gradient(149.09deg, #FFFFFF 18.55%, rgba(255, 255, 255, 0) 38.18%)',
      zIndex: -1,
    }}
    />
    <UploadInvoicesIcon sx={{ width: 118, height: 119, color: 'gray.A200' }} />
    <Stack alignItems="center" spacing={0.5}>
      <Typography variant="large_2" fontWeight={700} sx={{ color: 'gray.A600' }}>
        Aún no has cargado facturas en la plataforma
      </Typography>
      <Typography variant="medium_2" fontWeight={400} sx={{ color: 'gray.A400' }}>
        Elige cómo quieres subirlas
      </Typography>
    </Stack>
    <UploadInvoicesButton />
  </Stack>
);

export default AvailableFactoringOverlay;
